/* ==========================================================================
   BREATHMAXING VOLT — theme.js
   Cart drawer, AJAX add-to-cart, variant picker, quantity breaks,
   countdowns, sticky ATC, Meta Pixel event bridge.
   ========================================================================== */
(function () {
  'use strict';

  var BMX = window.BMX || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    var format = BMX.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    var noDecimals = String(Math.round(cents / 100));
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  /* ---------- Meta Pixel bridge ---------- */
  function pixel(event, params) {
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', event, params || {}); } catch (e) { /* noop */ }
    }
  }

  /* ---------- Toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bmx-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */
  var CartDrawer = {
    el: null,

    init: function () {
      this.el = $('#CartDrawer');
      if (!this.el) return;
      var self = this;

      $$('[data-cart-close]', this.el).forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
      $$('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      this.el.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-line-minus]');
        var plus = e.target.closest('[data-line-plus]');
        var remove = e.target.closest('[data-line-remove]');
        if (minus) self.changeLine(minus.getAttribute('data-line-minus'), -1);
        if (plus) self.changeLine(plus.getAttribute('data-line-plus'), 1);
        if (remove) self.removeLine(remove.getAttribute('data-line-remove'));

        var upsell = e.target.closest('[data-upsell-add]');
        if (upsell) {
          addToCart({ id: parseInt(upsell.getAttribute('data-upsell-add'), 10), quantity: 1 }, upsell);
        }
      });

      this.refresh();
    },

    open: function () {
      if (!this.el) return;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    refresh: function () {
      var self = this;
      fetch(BMX.cartUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },

    changeLine: function (line, delta) {
      var self = this;
      fetch(BMX.cartUrl + '.js').then(function (r) { return r.json(); }).then(function (cart) {
        var item = cart.items[parseInt(line, 10) - 1];
        if (!item) return;
        var qty = Math.max(0, item.quantity + delta);
        self.setLine(line, qty);
      });
    },

    removeLine: function (line) { this.setLine(line, 0); },

    setLine: function (line, qty) {
      var self = this;
      fetch(BMX.rootUrl + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },

    render: function (cart) {
      if (!this.el) return;

      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });

      var subtotal = $('[data-cart-subtotal]', this.el);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      var shipbar = $('[data-shipbar]', this.el);
      if (shipbar) {
        var threshold = BMX.freeShippingThreshold || 0;
        if (threshold > 0 && cart.item_count > 0) {
          shipbar.hidden = false;
          var remaining = threshold - cart.total_price;
          var pct = Math.min(100, (cart.total_price / threshold) * 100);
          var label = $('.shipbar__label', shipbar);
          if (remaining > 0) {
            label.innerHTML = 'You are <b>' + formatMoney(remaining) + '</b> away from FREE SHIPPING';
          } else {
            label.innerHTML = '<b>FREE SHIPPING UNLOCKED ⚡</b>';
          }
          $('.shipbar__fill', shipbar).style.width = pct + '%';
        } else {
          shipbar.hidden = true;
        }
      }

      var upsell = $('[data-cart-upsell]', this.el);
      if (upsell) {
        var upsellId = parseInt(upsell.getAttribute('data-upsell-variant') || '0', 10);
        var inCart = cart.items.some(function (i) { return i.variant_id === upsellId || i.product_id === parseInt(upsell.getAttribute('data-upsell-product') || '0', 10); });
        upsell.hidden = inCart || cart.item_count === 0;
      }

      var wrap = $('[data-cart-items]', this.el);
      var foot = $('[data-cart-foot]', this.el);
      if (!wrap) return;

      if (cart.item_count === 0) {
        wrap.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<p>Your cart is empty. Your lungs noticed.</p>' +
          '<a class="btn btn--volt" href="' + (BMX.allProductsUrl || BMX.rootUrl + 'collections/all') + '">START MAXING</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      wrap.innerHTML = cart.items.map(function (item, idx) {
        var line = idx + 1;
        var img = item.image
          ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_160x160$1$2')
          : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        return (
          '<div class="cart-line">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div></div>') +
            '<div>' +
              '<div class="cart-line__title">' + item.product_title + '</div>' +
              (variantTitle ? '<div class="cart-line__variant">' + variantTitle + '</div>' : '') +
              '<div class="cart-line__qty">' +
                '<button type="button" data-line-minus="' + line + '" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-line-plus="' + line + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div>' +
              '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
              '<button type="button" class="cart-line__remove" data-line-remove="' + line + '">Remove</button>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
  };

  /* ==========================================================================
     ADD TO CART (AJAX)
     ========================================================================== */
  function addToCart(payload, triggerEl) {
    if (triggerEl) { triggerEl.setAttribute('disabled', 'disabled'); }
    return fetch(BMX.rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (res) {
        var added = res.items ? res.items : [res];
        var first = added[0] || {};
        var totalValue = added.reduce(function (sum, it) {
          return sum + ((it.final_price || it.price || 0) / 100) * (it.quantity || 1);
        }, 0);
        if (!res.items) {
          totalValue = ((first.final_price || first.price || 0) / 100) * (payload.quantity || 1);
        }
        pixel('AddToCart', {
          content_ids: added.map(function (it) { return String(it.variant_id); }),
          content_type: 'product_variant',
          content_name: first.product_title,
          value: totalValue,
          currency: BMX.currency
        });
        if (BMX.cartDrawerEnabled && CartDrawer.el) {
          CartDrawer.open();
        } else {
          toast('Added to cart ⚡');
          CartDrawer.refresh();
        }
        return item;
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add to cart');
      })
      .then(function (item) {
        if (triggerEl) triggerEl.removeAttribute('disabled');
        return item;
      });
  }

  /* Quick-add buttons on product cards */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      addToCart({ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }, quick);
    }
    var checkout = e.target.closest('[data-checkout], [name="checkout"]');
    if (checkout) {
      pixel('InitiateCheckout', { currency: BMX.currency });
    }
  });

  /* ==========================================================================
     PRODUCT FORM (variant picker + qty breaks + buy)
     ========================================================================== */
  function ProductForm(root) {
    this.root = root;
    var jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    this.product = JSON.parse(jsonEl.textContent);
    var invEl = $('[data-inventory-json]', root);
    this.inventory = invEl ? JSON.parse(invEl.textContent) : {};
    this.currentVariant = this.findVariantById(parseInt(root.getAttribute('data-selected-variant'), 10)) || this.product.variants[0];
    this.tierQty = 1;
    this.tierPct = 0;
    this.split = null;
    this.initialLoad = true;
    this.bind();
    this.markSoldOutPills();
    this.resetSplit();
    this.updateUI();
    this.initialLoad = false;
  }

  ProductForm.prototype = {
    findVariantById: function (id) {
      return this.product.variants.filter(function (v) { return v.id === id; })[0];
    },

    selectedOptions: function () {
      return $$('.opt-group', this.root).map(function (group) {
        var active = $('.opt-pill.is-active', group);
        return active ? active.getAttribute('data-value') : null;
      });
    },

    matchVariant: function () {
      var opts = this.selectedOptions();
      return this.product.variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      })[0];
    },

    variantStock: function (vid) {
      var q = this.inventory ? this.inventory[String(vid)] : null;
      return (typeof q === 'number') ? Math.max(0, q) : Infinity;
    },

    resetSplit: function () {
      var el = $('[data-color-split]', this.root);
      if (!el) return;
      this.split = {};
      if (this.tierQty > 1 && this.product.variants.length > 1) {
        var self = this;
        var remaining = this.tierQty;
        var order = [String(this.currentVariant.id)].concat(
          this.product.variants.map(function (v) { return String(v.id); })
            .filter(function (id) { return id !== String(self.currentVariant.id); })
        );
        order.forEach(function (id) {
          var take = Math.min(remaining, self.variantStock(id));
          if (take > 0) { self.split[id] = take; remaining -= take; }
        });
        el.hidden = false;
      } else {
        el.hidden = true;
      }
      this.renderSplit();
    },

    adjustSplit: function (vid, delta) {
      if (!this.split) return;
      var self = this;
      var ids = this.product.variants.map(function (v) { return String(v.id); });
      var cur = this.split[vid] || 0;
      if (delta > 0) {
        if (cur >= this.tierQty || cur >= this.variantStock(vid)) return;
        var donor = ids.filter(function (id) { return id !== vid && (self.split[id] || 0) > 0; })
          .sort(function (a, b) { return (self.split[b] || 0) - (self.split[a] || 0); })[0];
        if (!donor) return;
        this.split[donor]--;
        this.split[vid] = cur + 1;
      } else {
        if (cur <= 0) return;
        var receiver = ids.filter(function (id) {
          return id !== vid && (self.split[id] || 0) < self.variantStock(id);
        })[0];
        if (!receiver) return;
        this.split[vid] = cur - 1;
        this.split[receiver] = (this.split[receiver] || 0) + 1;
      }
      this.renderSplit();
    },

    renderSplit: function () {
      var self = this;
      var ids = this.product.variants.map(function (v) { return String(v.id); });
      $$('[data-split-row]', this.root).forEach(function (row) {
        var vid = row.getAttribute('data-split-variant');
        var q = (self.split && self.split[vid]) || 0;
        var stock = self.variantStock(vid);
        var qEl = $('[data-split-qty]', row);
        if (qEl) qEl.textContent = q;
        row.classList.toggle('is-zero', q === 0);
        row.classList.toggle('is-oos', stock <= 0);
        var plus = $('[data-split-plus]', row);
        var minus = $('[data-split-minus]', row);
        var donorExists = ids.some(function (id) { return id !== vid && ((self.split && self.split[id]) || 0) > 0; });
        var receiverExists = ids.some(function (id) {
          return id !== vid && ((self.split && self.split[id]) || 0) < self.variantStock(id);
        });
        if (plus) plus.disabled = (q >= self.tierQty) || (q >= stock) || !donorExists;
        if (minus) minus.disabled = (q <= 0) || !receiverExists;
      });
    },

    markSoldOutPills: function () {
      if (this.product.options.length !== 1) return;
      var self = this;
      $$('.opt-pill', this.root).forEach(function (pill) {
        var val = pill.getAttribute('data-value');
        var v = self.product.variants.filter(function (x) { return x.options[0] === val; })[0];
        pill.classList.toggle('is-oos', !!(v && !v.available));
      });
    },

    splitItems: function () {
      if (!this.split || this.tierQty < 2) return null;
      var items = [];
      for (var vid in this.split) {
        if (this.split[vid] > 0) items.push({ id: parseInt(vid, 10), quantity: this.split[vid] });
      }
      return items.length ? items : null;
    },

    bind: function () {
      var self = this;

      $$('.opt-pill', this.root).forEach(function (pill) {
        pill.addEventListener('click', function () {
          var group = pill.closest('.opt-group');
          $$('.opt-pill', group).forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var v = self.matchVariant();
          if (v) { self.currentVariant = v; }
          self.resetSplit();
          self.updateUI();
        });
      });

      $$('[data-tier]', this.root).forEach(function (tier) {
        tier.addEventListener('click', function () {
          $$('[data-tier]', self.root).forEach(function (t) { t.classList.remove('is-active'); });
          tier.classList.add('is-active');
          self.tierQty = parseInt(tier.getAttribute('data-tier-qty'), 10) || 1;
          self.tierPct = parseFloat(tier.getAttribute('data-tier-pct')) || 0;
          var qtyInput = $('[data-qty-input]', self.root);
          if (qtyInput) qtyInput.value = self.tierQty;
          self.resetSplit();
          self.updateUI();
        });
      });

      $$('[data-split-row]', this.root).forEach(function (row) {
        var vid = row.getAttribute('data-split-variant');
        var plus = $('[data-split-plus]', row);
        var minus = $('[data-split-minus]', row);
        if (plus) plus.addEventListener('click', function () { self.adjustSplit(vid, 1); });
        if (minus) minus.addEventListener('click', function () { self.adjustSplit(vid, -1); });
      });

      $$('[data-qty-minus]', this.root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = $('[data-qty-input]', self.root);
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
        });
      });
      $$('[data-qty-plus]', this.root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = $('[data-qty-input]', self.root);
          input.value = parseInt(input.value, 10) + 1;
        });
      });

      $$('.gallery__thumb', this.root).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          $$('.gallery__thumb', self.root).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var main = $('[data-gallery-main]', self.root);
          if (main) {
            main.src = thumb.getAttribute('data-full');
            main.srcset = '';
          }
        });
      });

      $$('form[data-product-form]', this.root).forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var qtyInput = $('[data-qty-input]', self.root);
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : self.tierQty;
          var btn = $('[data-atc]', form) || $('[data-atc]', self.root);
          if (btn && btn.hasAttribute('disabled')) return;
          var items = self.splitItems();
          if (items) { addToCart({ items: items }, btn); }
          else { addToCart({ id: self.currentVariant.id, quantity: qty }, btn); }
        });
      });

      var stickyBtn = $('[data-sticky-atc-btn]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var qtyInput = $('[data-qty-input]', self.root);
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          var items = self.splitItems();
          if (items) { addToCart({ items: items }, stickyBtn); }
          else { addToCart({ id: self.currentVariant.id, quantity: qty }, stickyBtn); }
        });
      }
    },

    updateUI: function () {
      var v = this.currentVariant;
      var self = this;
      if (!v) return;

      $$('[data-variant-id-input]', this.root).forEach(function (input) { input.value = v.id; });

      var unit = v.price;
      var discounted = Math.round(unit * (1 - this.tierPct / 100));

      $$('[data-price-current]', document).forEach(function (el) { el.textContent = formatMoney(discounted); });
      $$('[data-price-compare]', document).forEach(function (el) {
        var compare = (v.compare_at_price && v.compare_at_price > unit) ? v.compare_at_price : (self.tierPct > 0 ? unit : 0);
        if (compare > discounted && compare > 0) {
          el.textContent = formatMoney(compare);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      $$('[data-tier]', this.root).forEach(function (tier) {
        var q = parseInt(tier.getAttribute('data-tier-qty'), 10) || 1;
        var pct = parseFloat(tier.getAttribute('data-tier-pct')) || 0;
        var total = Math.round(unit * q * (1 - pct / 100));
        var was = unit * q;
        var priceEl = $('[data-tier-price]', tier);
        var wasEl = $('[data-tier-was]', tier);
        if (priceEl) priceEl.textContent = formatMoney(total);
        if (wasEl) {
          if (pct > 0) { wasEl.textContent = formatMoney(was); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      });

      var atc = $('[data-atc]', this.root);
      if (atc) {
        if (v.available) {
          atc.removeAttribute('disabled');
          atc.textContent = atc.getAttribute('data-label-add') || 'ADD TO CART';
        } else {
          atc.setAttribute('disabled', 'disabled');
          atc.textContent = atc.getAttribute('data-label-soldout') || 'SOLD OUT';
        }
      }

      var stock = $('[data-stock-bar]', this.root);
      if (stock) {
        var qty = this.inventory[String(v.id)];
        var threshold = parseInt(stock.getAttribute('data-threshold'), 10) || 10;
        if (typeof qty === 'number' && qty > 0 && qty <= threshold) {
          stock.hidden = false;
          $('[data-stock-label]', stock).textContent = '🔥 ONLY ' + qty + ' LEFT — SELLING FAST';
          $('.stock-bar__fill', stock).style.width = Math.max(8, (qty / threshold) * 100) + '%';
        } else {
          stock.hidden = true;
        }
      }

      if (!this.initialLoad && v.featured_image && v.featured_image.src) {
        var main = $('[data-gallery-main]', this.root);
        if (main) { main.src = v.featured_image.src; main.srcset = ''; }
      }

      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(discounted);
    }
  };

  /* ==========================================================================
     STICKY ATC visibility
     ========================================================================== */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    });
    io.observe(anchor);
  }

  /* ==========================================================================
     COUNTDOWNS  (data-countdown, with data-ends OR data-hours evergreen)
     ========================================================================== */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var deadline;
      var ends = el.getAttribute('data-ends');
      if (ends) {
        deadline = new Date(ends).getTime();
      } else {
        var hours = parseFloat(el.getAttribute('data-hours')) || 24;
        var key = 'bmx_cd_' + (el.getAttribute('data-key') || 'default');
        deadline = parseInt(localStorage.getItem(key) || '0', 10);
        if (!deadline || deadline < Date.now()) {
          deadline = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(deadline)); } catch (e) { /* noop */ }
        }
      }
      if (isNaN(deadline)) return;

      var units = {
        d: $('[data-cd-d]', el), h: $('[data-cd-h]', el),
        m: $('[data-cd-m]', el), s: $('[data-cd-s]', el)
      };
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var diff = Math.max(0, deadline - Date.now());
        var d = Math.floor(diff / 86400000);
        var h = Math.floor(diff / 3600000) % 24;
        var m = Math.floor(diff / 60000) % 60;
        var s = Math.floor(diff / 1000) % 60;
        if (units.d) units.d.textContent = pad(d);
        if (units.h) units.h.textContent = pad(units.d ? h : h + d * 24);
        if (units.m) units.m.textContent = pad(m);
        if (units.s) units.s.textContent = pad(s);
        if (diff <= 0 && el.hasAttribute('data-hide-on-end')) el.style.display = 'none';
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ==========================================================================
     ANNOUNCEMENT ROTATOR
     ========================================================================== */
  function initAnnounce() {
    var bar = $('[data-announce]');
    if (!bar) return;
    var items = $$('.announce__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ==========================================================================
     HEADER (mobile menu)
     ========================================================================== */
  function initHeader() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('[data-site-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ==========================================================================
     COLLECTION SORT
     ========================================================================== */
  function initSort() {
    var sort = $('[data-sort-by]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }

  /* ==========================================================================
     RELATED PRODUCTS (Section Rendering API)
     ========================================================================== */
  function initRelated() {
    var wrap = $('[data-related-products]');
    if (!wrap || wrap.getAttribute('data-loaded') === 'true') return;
    var url = wrap.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-related-products]');
        if (inner && inner.innerHTML.trim().length) {
          wrap.innerHTML = inner.innerHTML;
          wrap.setAttribute('data-loaded', 'true');
        } else {
          var section = wrap.closest('.section');
          if (section) section.style.display = 'none';
        }
      });
  }

  /* ==========================================================================
     BOOT
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
    $$('[data-product-root]').forEach(function (root) { new ProductForm(root); });
    initStickyAtc();
    initCountdowns();
    initAnnounce();
    initHeader();
    initSort();
    initRelated();
  });

  window.BMXTheme = { addToCart: addToCart, CartDrawer: CartDrawer, formatMoney: formatMoney };
})();
